<template>
  <div class="settings-section">
    <div class="settings-container">
      <!-- 设置内容 -->
      <div class="settings-content">
        <div class="section-header">
          <div class="section-title">设置</div>
        </div>
        
        <div class="settings-form">
          <div class="form-group">
            <div class="form-label">我的头像：</div>
            <div class="form-content">
              <div class="avatar-wrapper">
                <img :src="displayUserInfo.avatar || require('@/assets/image/avatar_default.png')" alt="avatar" class="avatar-img" />
              </div>
            </div>
            <div class="edit-link" @click="openAvatarDialog">修改</div>
          </div>
          
          <div class="form-group">
            <div class="form-label">我的昵称：</div>
            <div class="form-content">
              <span class="info-text">{{ displayUserInfo.nickname }}</span>
            </div>
            <div class="edit-link" @click="editUserInfo('昵称')">修改</div>
          </div>

          <div class="form-group">
            <div class="form-label">手机号码：</div>
            <div class="form-content">
              <span class="info-text number-text">{{ displayUserInfo.phone }}</span>
            </div>
            <div class="edit-link" @click="editUserInfo('手机号')">修改</div>
          </div>

          <div class="form-group">
            <div class="form-label">实名认证：</div>
            <div class="form-content">
              <span class="info-text" :class="{ 'not-verified': !displayUserInfo.isRealNameVerified }">{{ realNameVerifiedText }}</span>
            </div>
            <div v-if="!displayUserInfo.isRealNameVerified" class="edit-link" @click="openRealNameVerify">去认证</div>
          </div>

<!--          <div class="form-group">-->
<!--            <div class="form-label">邮箱：</div>-->
<!--            <div class="form-content">-->
<!--              <span class="info-text number-text">{{ displayUserInfo.email }}</span>-->
<!--            </div>-->
<!--            <div class="edit-link" @click="editUserInfo('邮箱')">修改</div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <div class="form-label">身份证：</div>-->
<!--            <div class="form-content">-->
<!--              <span class="info-text number-text">{{ displayUserInfo.idCard }}</span>-->
<!--            </div>-->
<!--            <div class="edit-link" @click="editUserInfo('身份证')">修改</div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <div class="form-label">标签：</div>-->
<!--            <div class="form-content">-->
<!--              <span class="info-text">{{ displayUserInfo.tags }}</span>-->
<!--            </div>-->
<!--            <div class="edit-link" @click="editUserInfo('标签')">修改</div>-->
<!--          </div>-->
          
          <div class="form-group no-border">
            <div class="form-label">邮箱：</div>
            <div class="form-content">
              <span class="info-text number-text">{{ displayUserInfo.email || '未设置' }}</span>
            </div>
            <div class="edit-link" @click="editUserInfo('邮箱')">修改</div>
          </div>
          
          <div class="password-section">
            <div class="section-subtitle">密码设置</div>
            <div class="form-group no-border">
              <div class="form-label">我的密码：</div>
              <div class="form-content">
                <span class="info-text password-text">{{ loginPassword }}</span>
              </div>
              <div class="edit-link" @click="editPassword()">修改</div>
            </div>
          </div>
          
          <div class="form-actions">
            <el-button :loading="personalInfoSaving" class="save-btn" @click="saveSettings">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="80px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="passwordForm.phone" disabled placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div style="display: flex;">
            <el-input v-model="passwordForm.code" placeholder="请输入验证码" style="flex: 1; margin-right: 10px;"></el-input>
            <el-button type="primary" :disabled="codeCountdown > 0" @click="sendCode">
              {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" show-password placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" show-password placeholder="请输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="passwordSubmitting" @click="handlePasswordSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="实名认证"
      :visible.sync="realNameDialogVisible"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form :model="realNameForm" :rules="realNameRules" ref="realNameForm" label-width="80px">
        <el-form-item label="真实姓名" prop="name">
          <el-input v-model="realNameForm.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="realNameForm.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="realNameDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="realNameSubmitting" @click="handleRealNameVerify">提交认证</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改手机号"
      :visible.sync="phoneDialogVisible"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form :model="phoneForm" :rules="phoneRules" ref="phoneForm" label-width="80px">
        <el-form-item label="新手机号" prop="newPhone">
          <el-input v-model="phoneForm.newPhone" placeholder="请输入新手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div style="display: flex;">
            <el-input v-model="phoneForm.code" placeholder="请输入验证码" style="flex: 1; margin-right: 10px;"></el-input>
            <el-button type="primary" :disabled="phoneCodeCountdown > 0" @click="sendPhoneCode">
              {{ phoneCodeCountdown > 0 ? `${phoneCodeCountdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="phoneDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="phoneSubmitting" @click="handlePhoneSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改头像"
      :visible.sync="avatarDialogVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
      class="avatar-dialog"
    >
      <div class="avatar-dialog-content">
        <div class="avatar-section-title">推荐头像</div>
        <div class="default-avatars-list" v-loading="defaultAvatarsLoading">
          <div 
            v-for="(item, index) in defaultAvatars" 
            :key="index"
            class="default-avatar-item"
            :class="{ active: selectedAvatarUrl === item }"
            @click="selectedAvatarUrl = item"
          >
            <img :src="item" alt="推荐头像" />
            <div class="active-mask" v-if="selectedAvatarUrl === item">
              <i class="el-icon-check"></i>
            </div>
          </div>
          <div v-if="defaultAvatars.length === 0 && !defaultAvatarsLoading" class="empty-text">
            暂无推荐头像
          </div>
        </div>
        <!-- <div class="avatar-section-title" style="margin-top: 24px;">自定义头像</div>
        <el-upload
          class="custom-avatar-upload"
          action=""
          :show-file-list="false"
          :http-request="handleAvatarUpload"
          :before-upload="beforeAvatarUpload"
          accept="image/*"
        >
          <el-button size="small" type="primary" plain :loading="personalInfoSaving">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">支持 jpg、png、jpeg 格式，大小不超过 5MB</div>
        </el-upload> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="avatarDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="personalInfoSaving" @click="confirmAvatarSelection">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPersonalInfo, updatePersonalInfo, uploadFrontendFile, sendForgotPasswordSmsCode, resetPassword, verifyRealName, sendUpdatePhoneSmsCode, updatePhone, getDefaultAvatars } from '@/api/authApi'

export default {
  name: 'AppSettings',
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        avatar: '',
        nickname: '王二麻子',
        phone: '132****5341',
        userId: '3789'
      })
    },
    loginPassword: {
      type: String,
      default: '**********'
    }
  },
  data() {
    return {
      fetchedUserInfo: null,
      personalInfoLoading: false,
      personalInfoSaving: false,
      personalForm: {
        avatar: '',
        realName: '',
        phone: '',
        email: '',
        idCard: '',
        tags: '',
        password: ''
      },
      realNameDialogVisible: false,
      realNameSubmitting: false,
      realNameForm: {
        name: '',
        idCard: ''
      },
      realNameRules: {
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
        ]
      },
      // 修改密码相关数据
      passwordDialogVisible: false,
      passwordSubmitting: false,
      codeCountdown: 0,
      codeTimer: null,
      passwordForm: {
        phone: '',
        code: '',
        oldPassword: '',
        newPassword: ''
      },
      passwordRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      },
      // 修改手机号相关数据
      phoneDialogVisible: false,
      phoneSubmitting: false,
      phoneCodeCountdown: 0,
      phoneCodeTimer: null,
      phoneForm: {
        newPhone: '',
        code: ''
      },
      phoneRules: {
        newPhone: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      // 头像选择相关数据
      avatarDialogVisible: false,
      defaultAvatarsLoading: false,
      defaultAvatars: [],
      selectedAvatarUrl: ''
    }
  },
  computed: {
    displayUserInfo() {
      const info = this.fetchedUserInfo || this.userInfo || {}
      const realName = String((this.personalForm.realName || info.nickname || '')).trim()
      const phoneRaw = this.personalForm.phone || info.phone || ''
      const phoneMasked = this.maskMobile(phoneRaw)
      return {
        avatar: this.sanitizeUrl(this.personalForm.avatar || info.avatar),
        nickname: realName,
        phone: phoneMasked,
        email: String(this.personalForm.email || '').trim(),
        idCard: String(this.personalForm.idCard || '').trim(),
        tags: String(this.personalForm.tags || '').trim(),
        userId: info.userId || '',
        isRealNameVerified: this.normalizeRealNameVerified(info.isRealNameVerified),
        examNumber: info.examNumber || ''
      }
    },
    realNameVerifiedText() {
      const info = this.displayUserInfo || {}
      const value = info.isRealNameVerified
      if (value === true) return '已实名认证'
      if (value === false) return '未实名认证'
      return '未实名认证'
    }
  },
  created() {
    this.fetchPersonalInfo()
    this.tryOpenRealNameDialogFromRoute()
  },
  methods: {
    tryOpenRealNameDialogFromRoute() {
      const query = (this.$route && this.$route.query) || {}
      const openRealName = query.openRealName
      if (!(openRealName === 1 || openRealName === '1' || openRealName === true || openRealName === 'true')) return

      this.openRealNameVerify()
      const nextQuery = { ...query }
      delete nextQuery.openRealName
      this.$router.replace({ path: this.$route.path, query: nextQuery })
    },
    sanitizeUrl(url) {
      const raw = String(url || '').trim()
      if (!raw) return ''
      return raw.replace(/`/g, '').trim()
    },
    sanitizeDigits(value) {
      const raw = String(value || '').trim()
      if (!raw) return ''
      return raw.replace(/\D/g, '')
    },
    maskMobile(mobile) {
      const raw = String(mobile || '').trim()
      const digits = raw.replace(/\D/g, '')
      if (digits.length < 7) return raw
      return digits.replace(/(\d{3})\d+(\d{4})/, '$1****$2')
    },
    normalizeRealNameVerified(value) {
      if (value === true) return true
      if (value === false) return false
      if (value === 1 || value === '1') return true
      if (value === 0 || value === '0') return false
      return false
    },
    async openAvatarDialog() {
      this.selectedAvatarUrl = this.personalForm.avatar || this.fetchedUserInfo?.avatar || ''
      this.avatarDialogVisible = true
      if (this.defaultAvatars.length === 0) {
        this.fetchDefaultAvatars()
      }
    },
    async fetchDefaultAvatars() {
      this.defaultAvatarsLoading = true
      try {
        const res = await getDefaultAvatars()
        this.defaultAvatars = res.data || []
      } catch (err) {
        this.$message.error('获取推荐头像失败')
      } finally {
        this.defaultAvatarsLoading = false
      }
    },
    async confirmAvatarSelection() {
      if (!this.selectedAvatarUrl) {
        this.$message.warning('请选择头像')
        return
      }
      this.personalInfoSaving = true
      try {
        await updatePersonalInfo({ avatar: this.selectedAvatarUrl })
        this.personalForm.avatar = this.selectedAvatarUrl
        await this.fetchPersonalInfo()
        this.$message.success('头像更新成功')
        this.avatarDialogVisible = false
      } catch (err) {
        this.$message.error((err && err.message) || '头像更新失败')
      } finally {
        this.personalInfoSaving = false
      }
    },
    beforeAvatarUpload(file) {
      const sizeMb = file && file.size ? file.size / 1024 / 1024 : 0
      if (sizeMb && sizeMb > 5) {
        this.$message.error('头像大小不能超过5MB')
        return false
      }
      return true
    },
    async handleAvatarUpload(options) {
      const file = options && options.file
      if (!file) return
      this.personalInfoSaving = true
      try {
        const res = await uploadFrontendFile(file, 'avatar')
        const url = this.sanitizeUrl(res && res.data && res.data.url)
        if (!url) {
          throw new Error('上传失败：未返回url')
        }
        this.personalForm.avatar = url
        this.selectedAvatarUrl = url
        await updatePersonalInfo({ avatar: url })
        await this.fetchPersonalInfo()
        this.$message.success('头像更新成功')
        this.avatarDialogVisible = false
      } catch (err) {
        this.$message.error((err && err.message) || '头像上传失败')
      } finally {
        this.personalInfoSaving = false
      }
    },
    async fetchPersonalInfo() {
      if (this.personalInfoLoading) return
      this.personalInfoLoading = true
      try {
        const res = await getPersonalInfo()
        const data = (res && res.data) || {}
        const avatar = this.sanitizeUrl(data.avatar)
        const nickname = String((data.realName || data.username || '')).trim()
        const phone = this.maskMobile(data.phone)
        const userId = data.id != null ? String(data.id) : ''
        const isRealNameVerified = this.normalizeRealNameVerified(data.isRealNameVerified)
        this.fetchedUserInfo = { avatar, nickname, phone, userId, isRealNameVerified, examNumber: data.examNumber || '' }
        this.personalForm.avatar = avatar
        this.personalForm.realName = String(data.realName || data.username || '').trim()
        this.personalForm.phone = String(data.phone || '').trim()
        this.personalForm.email = String(data.email || '').trim()
        this.personalForm.idCard = String(data.idCard || '').trim()
        this.personalForm.tags = String(data.tags || '').trim()
        this.syncUserInfoToStore(data)
      } catch (err) {
        this.fetchedUserInfo = null
      } finally {
        this.personalInfoLoading = false
      }
    },
    syncUserInfoToStore(data) {
      if (!this.$store || !this.$store.dispatch) return
      const raw = data || {}
      if (!raw || typeof raw !== 'object') return
      this.$store.dispatch('auth/updateUserInfo', raw)
    },
    // 提交实名认证
    handleRealNameVerify() {
      this.$refs.realNameForm.validate(async valid => {
        if (valid) {
          this.realNameSubmitting = true
          try {
            const res = await verifyRealName(this.realNameForm)
            const data = res.data || {}
            if (data.passed) {
              this.$message.success('实名认证成功')
              this.realNameDialogVisible = false
              
              // 立即更新本地用户信息
              const info = this.fetchedUserInfo || {}
              this.fetchedUserInfo = {
                ...info,
                isRealNameVerified: true
              }
              // 同步到 store
              if (this.$store) {
                const current = this.$store.state.auth.userInfo || {}
                this.$store.dispatch('auth/updateUserInfo', {
                  ...current,
                  isRealNameVerified: true
                })
              }
              
              // 重新拉取最新信息（后台可能会更新其他字段）
              this.fetchPersonalInfo()
            } else {
              this.$message.error(data.reason || '认证失败')
            }
          } catch (err) {
            this.$message.error(err.message || '认证请求失败')
          } finally {
            this.realNameSubmitting = false
          }
        }
      })
    },
    openRealNameVerify() {
      this.realNameDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.realNameForm) {
          this.$refs.realNameForm.resetFields()
        }
      })
    },
    async editUserInfo(field) {
      const map = {
        '头像': { key: 'avatar', title: '修改头像', placeholder: '请输入头像链接' },
        '昵称': { key: 'realName', title: '修改昵称', placeholder: '请输入昵称' },
        '手机号': { key: 'phone', title: '修改手机号', placeholder: '请输入手机号' },
        '邮箱': { key: 'email', title: '修改邮箱', placeholder: '请输入邮箱' },
        '身份证': { key: 'idCard', title: '修改身份证', placeholder: '请输入身份证号' },
        '标签': { key: 'tags', title: '修改标签', placeholder: '例如：VIP,活跃用户' }
      }
      const cfg = map[field]
      if (!cfg) return

      // 手机号单独处理，需要验证码
      if (field === '手机号') {
        this.openPhoneDialog()
        return
      }

      const current = this.personalForm[cfg.key]
      try {
        const { value } = await this.$prompt(cfg.placeholder, cfg.title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: String(current || ''),
          inputPlaceholder: cfg.placeholder
        })
        if (cfg.key === 'avatar') {
          this.personalForm.avatar = this.sanitizeUrl(value)
          return
        }
        if (cfg.key === 'idCard') {
          this.personalForm.idCard = this.sanitizeDigits(value)
          return
        }
        this.personalForm[cfg.key] = String(value || '').trim()
      } catch (e) {
        return
      }
    },
    // 打开修改手机号对话框
    openPhoneDialog() {
      this.phoneForm = {
        newPhone: '',
        code: ''
      }
      this.phoneCodeCountdown = 0
      if (this.phoneCodeTimer) {
        clearInterval(this.phoneCodeTimer)
        this.phoneCodeTimer = null
      }
      this.phoneDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.phoneForm) {
          this.$refs.phoneForm.clearValidate()
        }
      })
    },
    // 发送修改手机号验证码
    async sendPhoneCode() {
      const phone = this.phoneForm.newPhone
      if (!phone) {
        this.$message.error('请先输入新手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('手机号格式不正确')
        return
      }
      try {
        await sendUpdatePhoneSmsCode({ phone })
        this.$message.success('验证码已发送')
        
        this.phoneCodeCountdown = 60
        if (this.phoneCodeTimer) clearInterval(this.phoneCodeTimer)
        this.phoneCodeTimer = setInterval(() => {
          this.phoneCodeCountdown--
          if (this.phoneCodeCountdown <= 0) {
            clearInterval(this.phoneCodeTimer)
            this.phoneCodeTimer = null
          }
        }, 1000)
      } catch (err) {
        this.$message.error(err.message || '发送失败')
      }
    },
    // 提交修改手机号
    handlePhoneSubmit() {
      this.$refs.phoneForm.validate(async valid => {
        if (valid) {
          this.phoneSubmitting = true
          try {
            await updatePhone({
              phone: this.phoneForm.newPhone,
              smsCode: this.phoneForm.code
            })
            this.$message.success('手机号修改成功')
            this.personalForm.phone = this.phoneForm.newPhone
            this.phoneDialogVisible = false
            await this.fetchPersonalInfo()
          } catch (err) {
            this.$message.error(err.message || '手机号修改失败')
          } finally {
            this.phoneSubmitting = false
          }
        }
      })
    },
    // 修改密码
    editPassword() {
      const phone = String(this.personalForm.phone || '').trim()
      if (!phone) {
        this.$message.error('请先完善手机号信息')
        return
      }
      
      this.passwordForm = {
        phone: phone,
        code: '',
        oldPassword: '',
        newPassword: ''
      }
      this.codeCountdown = 0
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
      }
      
      this.passwordDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate()
        }
      })
    },
    // 发送验证码
    async sendCode() {
      const phone = this.passwordForm.phone
      if (!phone) {
        this.$message.error('无有效手机号')
        return
      }
      try {
        await sendForgotPasswordSmsCode({ phone })
        this.$message.success('验证码已发送')
        
        this.codeCountdown = 60
        if (this.codeTimer) clearInterval(this.codeTimer)
        this.codeTimer = setInterval(() => {
          this.codeCountdown--
          if (this.codeCountdown <= 0) {
            clearInterval(this.codeTimer)
            this.codeTimer = null
          }
        }, 1000)
      } catch (err) {
        this.$message.error(err.message || '发送失败')
      }
    },
    // 提交修改密码
    handlePasswordSubmit() {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          this.passwordSubmitting = true
          try {
            await resetPassword({
              phone: this.passwordForm.phone,
              smsCode: this.passwordForm.code,
              newPassword: this.passwordForm.newPassword,
              oldPassword: this.passwordForm.oldPassword
            })
            this.$message.success('密码修改成功')
            this.passwordDialogVisible = false
          } catch (err) {
            this.$message.error(err.message || '密码修改失败')
          } finally {
            this.passwordSubmitting = false
          }
        }
      })
    },
    // 保存设置
    async saveSettings() {
      if (this.personalInfoSaving) return
      this.personalInfoSaving = true
      try {
        const payload = {
          avatar: this.sanitizeUrl(this.personalForm.avatar),
          email: String(this.personalForm.email || '').trim(),
          idCard: this.personalForm.idCard ? String(this.personalForm.idCard) : '',
          phone: this.personalForm.phone ? String(this.personalForm.phone) : '',
          realName: String(this.personalForm.realName || '').trim(),
          tags: String(this.personalForm.tags || '').trim()
        }
        const password = String(this.personalForm.password || '').trim()
        if (password) payload.password = password

        await updatePersonalInfo(payload)
        this.personalForm.password = ''
        await this.fetchPersonalInfo()
        this.$message({ message: '设置保存成功', type: 'success' })
      } catch (err) {
        this.$message.error((err && err.message) || '设置保存失败')
      } finally {
        this.personalInfoSaving = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
/* 设置页面样式 */
.settings-section {
  width: 100%;
  background: #fff;
  min-height: 100%;
  
  .settings-container {
    padding: 0;
  }
  
  .settings-content {
    background-color: #fff;
    padding: 0;
  }
  
  .section-header {
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;
    
    .section-title {
      font-size: 20px;
      font-weight: 600;
      color: #3E2CCD;
    }
  }
  
  .settings-form {
    width: 100%;
  }
  
  .form-group {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px dashed #e0e0e0;
    
    &.no-border {
      border-bottom: none;
    }
  }
  
  .form-label {
    width: 100px;
    font-size: 16px;
    color: #666;
  }
  
  .form-content {
    flex: 1;
    display: flex;
    align-items: center;
  }
  
  .avatar-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    
    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .info-text {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    
    &.number-text {
      font-family: Arial, sans-serif;
      font-weight: 600;
    }

    &.not-verified {
      color: #ff4d4f;
    }
    
    &.password-text {
      font-family: Arial, sans-serif;
      font-weight: bold;
      letter-spacing: 2px;
      font-size: 18px;
    }
  }
  
  .edit-link {
    color: #3E2CCD;
    cursor: pointer;
    font-size: 16px;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .password-section {
    margin-top: 10px;
    border-top: 1px dashed #e0e0e0;
    padding-top: 30px;
    
    .section-subtitle {
      font-size: 18px;
      font-weight: 600;
      color: #3E2CCD;
      margin-bottom: 20px;
    }
  }
  
  .form-actions {
    margin-top: 60px;
    display: flex;
    justify-content: center;
  }
  
  .save-btn {
    width: 100%;
    height: 50px;
    background: #3E2CCD;
    border-color: #3E2CCD;
    color: #fff;
    font-size: 18px;
    border-radius: 6px;
    
    &:hover {
      background: #3325ad;
      border-color: #3325ad;
    }
  }
}

.avatar-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
}

.avatar-dialog-content {
  .avatar-section-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 16px;
  }

  .default-avatars-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    min-height: 100px;
    
    .empty-text {
      width: 100%;
      text-align: center;
      color: #999;
      line-height: 100px;
    }

    .default-avatar-item {
      position: relative;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      cursor: pointer;
      box-sizing: border-box;
      border: 2px solid transparent;
      transition: all 0.3s;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }

      &.active {
        border-color: #3E2CCD;
      }

      .active-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          color: #fff;
          font-size: 24px;
        }
      }
    }
  }

  .custom-avatar-upload {
    margin-top: 10px;
  }
}
</style>
